import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    blocks: [
      {
        i: 'network-status',
        w: 3, h: 24, x: 0, y: 0, visible: true,
      },
      {
        i: 'top-5-ssid-by-traffic',
        w: 1, h: 21, x: 0, y: 24, visible: true,
      },
      {
        i: 'top-5-switch-by-traffic',
        w: 1, h: 21, x: 1, y: 24, visible: true,
      },
      {
        i: 'top-5-ap-by-traffic',
        w: 1, h: 21, x: 2, y: 24, visible: true,
      },
      {
        i: 'wireless-traffic-usage',
        w: 3, h: 24, x: 0, y: 45, visible: true,
      },
      {
        i: 'ap-channel-utilization',
        w: 3, h: 24, x: 0, y: 69, visible: true,
      },
      {
        i: 'top-5-poe-power',
        w: 1, h: 21, x: 0, y: 93, visible: true,
      },
      {
        i: 'top-5-cpu',
        w: 1, h: 21, x: 1, y: 93, visible: true,
      },
      {
        i: 'top-5-memory',
        w: 1, h: 21, x: 2, y: 93, visible: true,
      },
      {
        i: 'poe-power',
        w: 1, h: 21, x: 0, y: 114, visible: true,
      },
    ]
  },
  resource: "/users/dashboard",
  total: 3
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setBlocks: (state, action) => {
      state.data.blocks = action.payload;
    },
  },
});

export const { setBlocks } = dashboardSlice.actions;

export default dashboardSlice.reducer;